<template>
    <div class="about">
        <div class="banner">
            <img :src="setImg('about-banner')" alt="">
        </div>
        <div class="introduct w"> 
            <Head-title class="animate__animated" title="理工比特林克(苏州)软件信息技术服务有限公司" name="Company information"></Head-title>
            <div class="introduct-box">
                <div class="introduct-list">
                    <p>理工比特林克（苏州）软件信息技术服务有限公司，成立于2021年，位于苏州市吴中区经济技术开发区越溪街道吴中大道1421号太湖软件产业园智慧谷园区，国家高新技术企业，公司目前已完成ISO9001、20000、27001体系认证，参与了工信部三项行业标准的制定，拥有三十余项工业互联网领域软件著作权，是一家聚焦智能制造领域的创新型科技公司。</p>
                    <img :src="setImg('about-2')" alt="">
                </div>
                <div class="introduct-list">
                    <img :src="setImg('about-1')" alt="">
                    <p>产品针对工业企业数据接入工业互联网存在的实现复杂、维护成本高的问题，研发基于机器人流程自动化(RPA)的智能化识别的标识注册与解析技术，实现工业企业数据及标识自动获取、清洗、归类、生成、分配，并完成在二级节点的注册和解析。在采用自然语言数据处理(NLP).图像识别处理(OCR、oD)、机器学习(ML)等技术优化数据的输入与输出的同时，对外提供统—数据模型和接口规范，扩展了工业软件的应用领域，扩大工业软件的服务边界，使工业软件从服务单一企业内部上升为服务产业链</p>
                </div>
            </div>
            <Head-title class="animate__animated" title="联系我们" name="Contact us"></Head-title>
            <div class="address"> 
                <baidu-map class="bm-view" :center="infoWindow.position" :zoom="30">
                    <bm-info-window :position="infoWindow.position" title="地址：" :show="infoWindow.show" :autoPan="infoWindow.autoPan" :closeOnClick="infoWindow.closeOnClick">
                        <p v-text="infoWindow.contents"></p> 
                    </bm-info-window>
                </baidu-map>
            </div>
        </div>
    </div>
</template>

<script> 
    import HeadTitle from "@/components/HeadTitle";
    import { mapState } from 'vuex';
    export default {
        name: 'About',
        components: { 
            HeadTitle
        },
        mixins: [],
        computed: {
            ...mapState({ 
                active: state => state.app.active
            }), 
            infoWindow() {
                let info = {
                    show: true,
                    closeOnClick: false,
                    autoPan: false,
                    position:{lng: 120.58606049099328, lat: 31.209091482015655},
                    contents: '苏州市吴中22区吴中大道1421号太湖软件园6号楼13层'
                }
                if(this.active == 2) {
                    info.contents= '北京市海淀区北京理工大学国防科技园1号楼607';
                    info.position={lng: 116.317278, lat: 39.966901}
                }
                return info;
            }
        },
        methods: { 
            setImg(path) {
                return require(`@/assets/images/${path}.png`)
            }
        },
    }
</script>

<style lang="scss" scoped> 
$basePath: '~@/assets/images/';
@mixin setBgImg($imgName) {
    background: url($basePath +$imgName) no-repeat center;
}
.about{
   .introduct-box{
        display: flex;
        justify-content:space-between;
        p{
            font-size:20px;
            color:#666;
            line-height: 36px;
            margin-bottom: 62px;
        }
        img{
            width: 100%;
            height: 408px;
        }
        .introduct-list{
            width:667px;
            &:nth-child(2){
                width:696px;
                img{
                    height: 337px;
                }
                p{
                    margin-top:62px;
                    margin-bottom: 0;
                }
            }
        }
   }
   .address{
        margin: 0 auto;
        height:502px;
        width: 100%;
        .bm-view{
            height: 100%;
        }
    }
}
@media only screen and (max-width: 750px) { 
    .about{
        padding-bottom: 30px;
        .introduct-box{
            display: block;
            .introduct-list{
                margin-bottom: 15px;
                width: 100% !important; 
                p{
                    font-size:16px; 
                    width: 100%; 
                    margin-bottom: 10px;
                }
                img{
                    width: 100%; 
                    height: auto;
                }
                &:nth-child(2){ 
                    p{
                        margin-top: 10px;
                    }
                }
            }
        }
        .address{
            width: 100%;
            height: 300px;
        }
    }
}
</style>
<style lang="scss">
    .introduct{
        .title{
            padding:117px 0;
        }
    }
    @media only screen and (max-width: 750px) { 
        .introduct{
            .title{
                padding:20px 0 30px;
                height: auto;
                span{
                    height: auto;
                }
                em{
                    padding: 0 20px;
                }
            }
        }
    }
</style>